// filepath: apps/web/src/features/cabinet/RequiredUserParameters/RequiredUserParametersRoute.tsx
//
// FR-UI-CABINET-3 — thin route wrapper around RequiredUserParametersPage.
//
// Mounted inside <AuthGuard> at /cabinet/required-parameters (see
// App.tsx). The wrapper is kept separate from the page component so
// tests can render the page directly without going through the
// router.

import React from "react";
import { RequiredUserParametersPage } from "./RequiredUserParametersPage";

export function RequiredUserParametersRoute(): React.ReactElement {
  return <RequiredUserParametersPage />;
}
